<template>
  <g>
    <rect width="25" height="25" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8006 9.18042C17.066 8.91496 17.0653 8.4851 16.8013 8.22104L16.779 8.19874C16.5142 7.93398 16.0857 7.93329 15.8196 8.19944L13.48 10.539C13.2146 10.8044 12.7861 10.8051 12.52 10.539L10.1804 8.19944C9.91496 7.93399 9.4851 7.93468 9.22104 8.19874L9.19874 8.22104C8.93398 8.48579 8.93329 8.91427 9.19944 9.18042L11.539 11.52C11.8044 11.7854 11.8051 12.2139 11.539 12.48L9.19944 14.8196C8.93399 15.085 8.93468 15.5149 9.19874 15.779L9.22104 15.8013C9.48579 16.066 9.91427 16.0667 10.1804 15.8006L12.52 13.461C12.7854 13.1956 13.2139 13.1949 13.48 13.461L15.8196 15.8006C16.085 16.066 16.5149 16.0653 16.779 15.8013L16.8013 15.779C17.066 15.5142 17.0667 15.0857 16.8006 14.8196L14.461 12.48C14.1956 12.2146 14.1949 11.7861 14.461 11.52L16.8006 9.18042Z"
      fill="#3C4A50"
    />
  </g>
</template>
<script>
export default {
  name: 'icon-square-x',
}
</script>
